module.exports = __webpack_public_path__ + "static/media/puzzle-18-bg.aebdb355.svg";